import { useTheme } from '@mui/material';
import { useMemo } from 'react';
import useDesignTokens from '@assetron/web-common/themes/useDesignTokens';

const useFailureDialogStyles = () => {
  const theme = useTheme();
  const tokens = useDesignTokens();

  const styles = useMemo(() => {
    return {
      rootContainer: {
        flex: '1',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        paddingTop: theme.sizeGuide['8xl'],
        [theme.breakpoints.down('sm')]: {
          padding: `${theme.sizeGuide['4xl']} ${theme.sizeGuide.xl}`,
        },
      },
      mainBox: {
        width: '512px',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        gap: theme.sizeGuide['4xl'],
      },
      header: {
        color: tokens.colors.text.primary,
        textAlign: 'center',
      },
      description: {
        color: tokens.colors.text.secondary,
        textAlign: 'center',
      },
      content: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        gap: theme.sizeGuide.xl,
      },
    };
  }, [theme, tokens]);

  return styles;
};

export default useFailureDialogStyles;
